<template>
  <div class="archives-information">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート / {{ year }} 年 / お知らせ</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-area">
      <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
    </div>
    <div class="section">
      <div class="container" v-if="displayDataCreated">
        <table class="stripe">
          <tr>
            <th class="no">#</th>
            <th class="time">投稿日時</th>
            <th class="contributor">投稿者</th>
            <th class="title">タイトル</th>
            <th class="contents">内容</th>
            <th class="path">画像</th>
          </tr>
          <tr
            v-for="(row, index) in informationList"
            :key="index"
            class="tr-datas"
            @click="showRefFrame(index)"
          >
            <td style="text-align: center">{{ index + 1 }}</td>
            <td style="text-align: center">{{ formatDatetime(row.datetime, 'YYYY/MM/DD HH:mm') }}</td>
            <td>{{ row.contributor }}</td>
            <td>{{ row.title }}</td>
            <td>{{ row.contents }}</td>
            <template v-if="row.image_paths && row.image_paths.length > 0">
              <td class="image-cell">
                <div class="ic-images" />
              </td>
            </template>
            <template v-else>
              <td/>
            </template>
          </tr>
          <tr v-if="informationList.length < masterInformationList.length">
            <td colspan="5" class="list-message" @click="onClickAllItem">
              <span> すべてを見る </span>
            </td>
          </tr>
          <tr v-if="masterInformationList.length === 0">
            <td colspan="5" class="no-message">
              <span> 登録されてるデータがありません </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      v-if="showCenterFrame"
      class="center-frame-container"
    >
      <transition name="scale" appear>
        <div class="center-frame">
          <div class="title-area">
            <h3>{{ informationInfo.title }}</h3>
            <div class="btn-close" @click="hideCenterFrame"></div>
          </div>
          <section class="frame-section">
            <div class="container">
              <div class="contents-body">
                <span class="textarea">{{ informationInfo.contents }}</span>
              </div>
              <div class="contents-footer">
                <span
                  >{{
                    formatDatetime(
                      informationInfo.datetime,
                      "YYYY/MM/DD HH:mm:ss"
                    )
                  }}
                  &nbsp; {{ informationInfo.contributor }}</span
                >
                <div class="image-area-view">
                  <template v-for="(row, index) in informationInfo.image_urls">
                    <div :key="index">
                      <img :src="row" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </section>
          <div id="button-area">
            <div class="left-box" />
            <div class="center-box" />
            <div class="right-box" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import XLSX from "xlsx";
import { Storage } from "aws-amplify";

const LIST_COUNT = 10;

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      year: null,
      displayDataCreated: false,
      informationList: [],
      informationInfo: null,
      masterInformationList: [],
      showCenterFrame: false,
    };
  },

  computed: {
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      try {
        await this.searchInformations();
        this.year = await this.getCurrentYear();
      } catch (error) {
        console.log(error);
        alert(error);
      }
    });
  },

  methods: {
    ...mapActions(["retrieveAllInformations"]),
    ...mapGetters(["getCurrentYear"]),

    async searchInformations() {
      this.informationList = [];
      try {
        const result = await this.retrieveAllInformations();
        this.masterInformationList = result.list;
        this.informationList = this.informationList.concat(
          this.masterInformationList.slice(0, LIST_COUNT)
        );
      } catch (error) {
        console.log(error);
      }
      this.displayDataCreated = true;
    },

    excelDownload() {
      var ws_data = [
        [
          "#",
          "投稿日時",
          "投稿者",
          "タイトル",
          "内容",
          "画像",
        ],
      ];
      for (let i = 0; i < this.masterInformationList.length; i++) {
        const item = this.masterInformationList[i];
        let rowValue = [];
        rowValue.push(i + 1);
        rowValue.push(this.formatDatetime(item.datetime, 'YYYY/MM/DD HH:mm:ss'));
        rowValue.push(item.contributor);
        rowValue.push(item.title);
        rowValue.push(item.contents);
        rowValue.push(this.getDisplayImages(item.image_paths));
        ws_data.push(rowValue);
      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_information_" +
        this.formatDatetime(dt, 'YYYYMMDDHHmmss') +
        ".xlsx";
      link.click();
    },

    onClickAllItem() {
      this.informationList = this.informationList.concat(
        this.masterInformationList.slice(LIST_COUNT)
      );
    },

    formatDatetime(src, format = "MM/DD HH:mm") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      return dest;
    },
    
    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    getDisplayImages(imagePaths) {
      if (imagePaths) {
        return imagePaths.length > 0 ? "有": "";
      }
      return "";
    },

    async showRefFrame(index) {
      this.informationInfo = this.informationList[index];
      this.informationInfo.image_urls = [];
      if (this.informationInfo.image_paths) {
        try {
          for (const path of this.informationInfo.image_paths) {
            const url = await Storage.get(path);
            this.informationInfo.image_urls.push(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      this.showCenterFrame = true;
    },
    hideCenterFrame() {
      this.showCenterFrame = false;
    },
  },
};
</script>

<style lang="scss">
.archives-information {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
    max-height: calc(100vh - 200px);
    margin-left: auto;
    margin-right: auto;

    .container {
      padding-right: 10px;
      padding-bottom: 10px;
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    table-layout: fixed;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;
    &.no {
      width: 5%;
      min-width: 20px;
      text-align: center;
    }
    &.time {
      width: 15%;
      min-width: 150px;
      max-width: 150px;
      text-align: center;
    }
    &.contributor {
      width: 15%;
      text-align: center;
    }
    &.title {
      width: 30%;
      text-align: center;
    }
    &.contents {
      width: 30%;
      text-align: center;
    }
    &.path {
      width: 5%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  .tr-datas {
    cursor: pointer;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }

  .list-message {
    text-align: center;
    cursor: pointer;

    span {
      color: var(--col3);
    }
  }
  .no-message {
    text-align: center;

    span {
      color: #555;
    }
  }
  .image-cell {
    text-align: center;
    cursor: pointer;
  }

  .button-area {
    height: calc(100% - 130px);
    position: relative;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 20px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }

  .ic-images {
    background: url("~@/assets/icons/ic_photo_active.svg") no-repeat center
      center;
    height: 20px;
    width: 20px;
    display: block;
    margin: auto;
  }

  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      // position: absolute;
      position: fixed;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;
    }

    .title-area {
      width: 100%;
      // height: 80px;
      min-height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }
    .frame-section {
      // overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        .contents-body {
          margin: 10px;

          &.scroll {
            max-height: 50vh;
            overflow-y: scroll;
          }

          span.textarea {
            white-space: pre-line;
          }

          dl.columns {
            width: 100%;
            display: grid;
            grid-template-columns: 180px 1fr;
            align-items: top;
            grid-gap: 0px 0px;
            margin: 0;
            padding: 0;
            font-size: 16px;
            color: #333;

            .mobile & {
              grid-template-columns: 1fr 1.5fr;
            }
          }

          .columns dt {
            display: block;
            text-align: right;
            width: 100%;
            margin: 0;
            padding: 16px;
          }

          .columns dd {
            display: block;
            width: 100%;
            border-left: solid 1px #ddd;
            margin: 0;
            padding: 16px;
          }
        }

        .contents-footer {
          margin: 10px;
        }
      }
    }
  }
  .image-area-view {
    width: 100%;

    img {
      max-width: 100%;
      margin: 10px 0px;
    }
  }

  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }
}
</style>
